import { render, staticRenderFns } from "./VolunteerHeader.vue?vue&type=template&id=361a3288&scoped=true"
import script from "./VolunteerHeader.vue?vue&type=script&lang=js"
export * from "./VolunteerHeader.vue?vue&type=script&lang=js"
import style0 from "./VolunteerHeader.vue?vue&type=style&index=0&id=361a3288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361a3288",
  null
  
)

export default component.exports